import { getField } from 'vuex-map-fields'
// import store from '@/store'

export default {
  documentsList: state => state.documentsList,
  currentDocument: state => state.currentDocument,
  emptyDocuments: function (state) {
    // console.log(state)
    // let emptyDocuments = []
    // console.log(store.state.user.allowB)
    // state.emptyDocuments.forEach((element) => {
    //   if (element.name === 'rezervirovanie') {
    //     console.log(element)
    //   }
    // })
    return state.emptyDocuments
  },
  defaultDocument: state => state.defaultDocument,
  itemsDisplaySettings: (state) => (settingsName) => state.itemsDisplaySettings[settingsName],
  currentFolderId: state => state.currentFolderId,
  itemsTableContent: state => state.itemsTableContent,
  itemsTableContentData: state => state.itemsTableContent,
  foldersTreeContent: state => state.foldersTreeContent,
  tableLoading: state => state.tableLoading,
  treeSideBar: state => state.treeSideBar,
  error: state => state.error,
  getSearchQuery: state => state.searchQuery,
  isSaving: state => state.isSaving,
  getField
}
